<template>
  <div class="lp-page enterprise-page">
    <Navbar />

    <!-- Hero -->
    <section class="lp-hero">
      <div class="lp-container">
        <span class="lp-eyebrow">{{ $t('enterprise.heroLabel') }}</span>
        <h1 class="lp-title">{{ $t('enterprise.heroTitle') }}</h1>
        <p class="lp-lead">{{ $t('enterprise.heroSubtitle') }}</p>
      </div>
    </section>

    <!-- Features (industries) -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-section-head">
          <h2 class="lp-h2">{{ $t('enterprise.featuresTitle') }}</h2>
        </div>
        <div class="lp-grid lp-grid-3">
          <div class="lp-card">
            <span class="lp-ico blue"><font-awesome-icon icon="fa-solid fa-shield-halved" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.securityTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.securityDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico green"><font-awesome-icon icon="fa-solid fa-truck" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.transportTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.transportDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico violet"><font-awesome-icon icon="fa-solid fa-prescription-bottle-medical" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.pharmacyTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.pharmacyDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico amber"><font-awesome-icon icon="fa-solid fa-warehouse" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.warehouseTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.warehouseDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico cyan"><font-awesome-icon icon="fa-solid fa-store" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.retailTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.retailDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico pink"><font-awesome-icon icon="fa-solid fa-industry" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.manufacturingTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.manufacturingDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico blue"><font-awesome-icon icon="fa-solid fa-building" /></span>
            <h3 class="lp-h3">{{ $t('enterprise.corporateTitle') }}</h3>
            <p class="lp-text">{{ $t('enterprise.corporateDescription') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits -->
    <section class="lp-section">
      <div class="lp-narrow">
        <div class="lp-section-head">
          <h2 class="lp-h2">{{ $t('enterprise.benefitsTitle') }}</h2>
        </div>
        <div class="benefits-list">
          <div class="benefit-item reveal-item" v-for="i in 6" :key="i">
            <span class="hl-tick"><font-awesome-icon icon="fa-solid fa-check" /></span>
            <div>
              <h3>{{ $t(`enterprise.benefit${i}Title`) }}</h3>
              <p class="lp-text">{{ $t(`enterprise.benefit${i}Description`) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-cta">
          <h2>{{ $t('enterprise.ctaTitle') }}</h2>
          <p>{{ $t('enterprise.ctaSubtitle') }}</p>
          <a href="/contact" class="lp-btn lp-btn-primary">{{ $t('enterprise.contactSales') }}</a>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import { useReveal } from '../composables/useReveal';

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'instant' });
});

useReveal();
</script>

<style scoped>
.benefits-list { display: grid; grid-template-columns: repeat(2, 1fr); gap: 18px 32px; }
.benefit-item { display: flex; gap: 14px; align-items: flex-start; }
.hl-tick { width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0; background: rgba(43,130,240,0.12); color: var(--violet); display: inline-flex; align-items: center; justify-content: center; font-size: 13px; margin-top: 2px; }
.benefit-item h3 { font-size: 16px; font-weight: 700; color: var(--ink); margin: 0 0 4px; }

@media (max-width: 768px) {
  .benefits-list { grid-template-columns: 1fr; }
}
</style>
